<template>
  <section class="mb-4" id="other">
    <section-title>
      {{ $t("documents-others") }}
    </section-title>
    <div class="row">
      <div class="col-lg-6">
        <vita-contrat-de-prestation
          @clicked="loadedContratDePrestation = true"
        ></vita-contrat-de-prestation>
        <vita-my-synthesis-sheet @clicked="loadedMySynthesisSheet = true">
        </vita-my-synthesis-sheet>
      </div>
      <div class="col-lg-6">
        <vita-recu-fiscal @clicked="loadedRecuFiscal = true"></vita-recu-fiscal>
      </div>
    </div>
  </section>
</template>

<script>
import SectionTitle from "../../SectionTitle.vue";
import VitaRecuFiscal from "../RecuFiscal/RecuFiscal.vue";
import VitaContratDePrestation from "../ContratDePrestation/ContratDePrestation.vue";
import VitaMySynthesisSheet from "../MySynthesisSheet/MySynthesisSheet.vue";
import DownloadPdf from "../../Mixins/downloadPdf.js";

export default {
  components: {
    SectionTitle,
    VitaRecuFiscal,
    VitaContratDePrestation,
    VitaMySynthesisSheet
  },
  mixins: [DownloadPdf],
  data() {
    return {
      loadedContratDePrestation: false,
      loadedRecuFiscal: false,
      loadedMySynthesisSheet: false
    };
  }
};
</script>
